import React from "react";
import Support from "../../pages/support"; // Importing your existing web support script

export default function MobileSupport() {
  return (
    <div style={styles.mobileWrapper} className="mobile-support-container">
      <Support />

      {/* CSS Overrides to fix overflowing fields and adapt layout for mobile */}
      <style>{`
        /* 1. Reset container padding and force vertical stack */
        .mobile-support-container > div {
          padding: 10px 0 !important;
          gap: 15px !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
        }

        /* 2. Fix the Card and FAQ width to stay within mobile screen */
        .mobile-support-container div[style*="maxWidth: 500"],
        .mobile-support-container form {
          max-width: 100% !important;
          width: 100% !important;
          box-sizing: border-box !important; /* Prevents padding from adding to width */
        }

        /* 3. Correct the Input/Textarea overflowing */
        .mobile-support-container input, 
        .mobile-support-container textarea {
          width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important; /* Crucial for preventing overflow */
          font-size: 16px !important; /* Prevents iOS auto-zoom on focus */
        }

        /* 4. Adjust FAQ question rows to wrap text instead of overflowing */
        .mobile-support-container div[style*="justifyContent: space-between"] {
          display: flex !important;
          gap: 10px !important;
          text-align: left !important;
        }

        .mobile-support-container h2 {
          font-size: 22px !important;
          text-align: center !important;
        }

        /* 5. Clean up shadow and borders for a flatter mobile look */
        .mobile-support-container div[style*="background: #0f172a"] {
          box-shadow: none !important;
          border: 1px solid rgba(255, 255, 255, 0.05) !important;
          padding: 16px !important;
        }
      `}</style>
    </div>
  );
}

const styles = {
  mobileWrapper: {
    width: "100%",
    padding: "0 12px",
    background: "#080b11",
    minHeight: "100vh",
    boxSizing: "border-box", // Ensures padding doesn't push the width beyond 100%
    overflowX: "hidden" // Extra safety against horizontal scroll
  }
};